import { ProductV2, sortProducts } from '@common'
import cx from 'classnames'

import { ProductCategoryHeader as CrProductCategoryHeader } from '../../clashroyale/Products/ProductCategoryHeader'
import { useGameSlug } from '../../game-provider'
import { CardSingleProduct, ProductCardContentType } from '../card/CardSingleProduct'
import SideScrollable from '../structure/SideScrollable'
import { BrawlProductsContainer } from './BrawlProductsContainer'
import { usePriceTextScalingRatio } from './helpers'
import { ProductCategoryHeader } from './ProductCategoryHeader'

import styles from './ProductCategory.module.scss'

interface ProductCategoryProps {
  title: string
  displayTitle?: boolean
  products: ProductV2[]
  productType: ProductCardContentType
}

export const ProductCategory = ({ title, products, productType, displayTitle = true }: ProductCategoryProps) => {
  const gameSlug = useGameSlug()
  const sorted = products.filter((product) => productType in product.contentCounts).sort(sortProducts)
  const scaling = usePriceTextScalingRatio(sorted)

  return (
    <div className={cx(styles.ProductCategory, styles[gameSlug])}>
      {displayTitle &&
        (gameSlug === 'clashroyale' ? (
          <CrProductCategoryHeader title={title} />
        ) : (
          <ProductCategoryHeader title={title} />
        ))}
      {gameSlug === 'brawlstars' ? (
        <BrawlProductsContainer>
          {sorted.map((product, index) => (
            <CardSingleProduct key={index} product={product} productType={productType} textScaling={scaling} />
          ))}
        </BrawlProductsContainer>
      ) : (
        <SideScrollable>
          {sorted.map((product, index) => (
            <CardSingleProduct key={index} product={product} productType={productType} textScaling={scaling} />
          ))}
        </SideScrollable>
      )}
    </div>
  )
}
